import {
  Directive,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  inject,
  input,
  output,
} from '@angular/core';
import $ from 'jquery';
import { SiaGridColConfig } from '../interfaces/sia-grid-col-config';

@Directive({
  selector: '[resizeColumn]',
  standalone: true,
})
export class ResizeColumnDirective implements OnInit, OnDestroy {
  private el = inject(ElementRef);

  readonly resizable = input<boolean>(false, { alias: 'resizeColumn' });
  readonly columnConfig = input<SiaGridColConfig>({});
  readonly gridId = input<string | undefined>();
  readonly columnConfigChange = output<SiaGridColConfig>();

  private renderer = inject(Renderer2);
  private startX?: number;
  private startWidth?: number;
  private column: HTMLElement;
  private table?: HTMLElement;
  private pressed?: boolean;
  latestSize: number = 0;
  mouseMoveListener?: () => void;
  mouseDown?: () => void;
  mouseUp?: () => void;
  wait = false;
  private _timeouts: any[] = [];

  constructor() {
    this.column = this.el.nativeElement;
    this.throttle = this.throttle.bind(this);
  }

  throttle(event: MouseEvent) {
    if (this.wait) {
      return;
    }
    this.onMouseMove(event);
    this.wait = true;
    let t = setTimeout(() => {
      this.wait = false;
    }, 50);
    this._timeouts.push(t);
  }

  ngOnInit() {
    if (this.resizable()) {
      const row = this.renderer.parentNode(this.column);
      const thead = this.renderer.parentNode(row);
      this.table = this.renderer.parentNode(thead);
      const resizer = this.renderer.createElement('span');
      this.renderer.addClass(resizer, 'resize-holder');
      this.renderer.appendChild(this.column, resizer);
      this.mouseDown = this.renderer.listen(
        resizer,
        'mousedown',
        this.onMouseDown,
      );
      this.mouseUp = this.renderer.listen(
        'document',
        'mouseup',
        this.onMouseUp,
      );
    }
  }

  ngOnDestroy() {
    if (this.mouseDown) {
      this.mouseDown();
    }
    if (this.mouseUp) {
      this.mouseUp();
    }
    this.table?.removeEventListener('mousemove', this.throttle);
    this._timeouts?.forEach((t) => {
      clearTimeout(t);
    });
    this._timeouts = [];
  }

  onMouseDown = (event: MouseEvent) => {
    this.table?.addEventListener('mousemove', this.throttle, {
      passive: true,
    });
    this.pressed = true;
    this.startX = event.pageX;
    this.startWidth = this.column.offsetWidth;
  };

  onMouseMove = (event: MouseEvent) => {
    if (!this.table) {
      return;
    }

    const offset = 35;
    if (this.pressed && event.buttons) {
      this.renderer.addClass(this.table, 'resizing');
      let width =
        (this.startWidth ?? 0) + (event.pageX - (this.startX ?? 0) - offset);
      const config = this.columnConfig();
      config.currentWidth = width;
      this.columnConfigChange.emit(config);

      const gridId = this.gridId();
      if (gridId && config.dataField) {
        $('.' + gridId + ' .mat-column-' + config.dataField).css(
          'width',
          `${width}px`,
        );
        $('.' + gridId + ' .mat-column-' + config.dataField + '-filter').css(
          'width',
          `${width}px`,
        );
      }
    }
  };

  onMouseUp = (event: MouseEvent) => {
    if (this.pressed) {
      this.pressed = false;
      this.renderer.removeClass(this.table, 'resizing');
      this.table?.removeEventListener('mousemove', this.throttle);
    }
  };
}
